<template>
    <form @submit.prevent="handleSubmit()">
        <div class="form-row">
            <div class="form-group col-md-6">
                <label>Date d'opération <span class="text-danger">*</span></label>
                <input type="date" class="form-control" v-model="form.date_operation" required :disabled="readOnly"/>
            </div>
            <div class="form-group col-md-6">
                <label>Bénéficiaire <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="form.beneficiaire" required :disabled="readOnly"/>
            </div>
            <div class="form-group col-md-6">
                <label>Décaisseur <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="form.decaisseur" required :disabled="readOnly"/>
            </div>
            <div class="form-group col-md-6">
                <label>Montant <span class="text-danger">*</span></label>
                <input type="number" class="form-control" v-model="form.montant" required :disabled="readOnly"/>
            </div>
        </div>
        <div class="form-group">
             <label>Libelle <span class="text-danger">*</span></label>
             <input type="text" class="form-control" v-model="form.libelle" required :disabled="readOnly"/>
         </div>
        <div class="form-group">
             <label> Motif </label>
             <TextEditor v-model="form.motif" editorStyle="height: 100px">
                 <template v-slot:toolbar>
                 <span class="ql-formats">
                     <button v-tooltip.bottom="'Bold'" class="ql-bold"></button>
                     <button v-tooltip.bottom="'Italic'" class="ql-italic"></button>
                     <button v-tooltip.bottom="'Underline'" class="ql-underline"></button>
                 </span>
                 </template>
             </TextEditor>
         </div>
         <button type="submit" class="btn btn-primary btn-block" :disabled="isLoading">
             <i class="fa-solid fa-save "></i> Enregistrer
             <span v-if="isLoading == true" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
         </button>
    </form>
 </template>
 <script>
 import $ from "jquery";
 import moment from 'moment'
 import { defineComponent } from 'vue';
 
 export default defineComponent({
    name: 'FormCaisse',
    inject: ['dialogRef'],
    props: {
        line: {
            type: Object,
            default: null,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isLoading: false,
            table: 'piece_de_caisses',
            baseUrl: this.$store.getters.apiCourses,
            form: {
                date_operation: moment().format('YYYY-MM-DD')
            },
        }
    },
    computed: {
        buttonLabel() {
            return this.line ? "Mettre à jour" : "Enregistrer";
        },
    },
    mounted() {
        if (this.line) {
            this.form = { ...this.line };
        }
    },
    methods: {
        handleSubmit() {
            this.isLoading = true
            let url = this.$store.getters.apiCourses +'/api/piece_de_caisses'
            if (this.line) {
                url = this.$store.getters.apiCourses +'/api/piece_de_caisses/' + this.line.id + '/update'
            }
            this.axios.post(url, this.form).then(response => {
                this.isLoading = false
                 if (response.data.success === true) {
                    this.resetForm()
                    $('#refresh' + this.table).click()
                    this.dialogRef.close()
                    this.$toast.add({
                        severity: 'success',
                        detail: response.data.message,
                        life: 3000
                    });
                } else {
                     response.data.errors.forEach(element => {
                        this.$toast.add({
                            severity: 'warn',
                            summary: 'Oups !',
                            detail: element,
                            life: 7000
                        });
                    });
                }
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        resetForm() {
            this.form = {
                 date_operation: moment().format('YYYY-MM-DD'),
            },
            this.lastId = 1
        }
    }
 })
 </script>